import { render } from "./k-app-topbar.vue?vue&type=template&id=1f6ecb95"
import script from "./k-app-topbar.vue?vue&type=script&lang=js"
export * from "./k-app-topbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__